import axios from 'axios';

let _cache = { ts: 0, payload: null };
const CACHE_MS = 60 * 1000;

export async function fetchData() {
  const apiKey = process.env.REACT_APP_ALPHA_VANTAGE_KEY || 'demo';
  const symbol = process.env.REACT_APP_SYMBOL || 'IBM';
  const base = 'https://www.alphavantage.co/query';

  const now = Date.now();
  if (_cache.payload && now - _cache.ts < CACHE_MS) {
    return _cache.payload; // { data, meta }
  }

  const parseSeries = (json) => {
    if (json?.Note) throw new Error('Alpha Vantage limit: ' + json.Note);
    if (json?.Information) throw new Error('Alpha Vantage info: ' + json.Information);
    if (json?.['Error Message']) throw new Error('Alpha Vantage error: ' + json['Error Message']);

    const seriesKey = Object.keys(json || {}).find(k => /Time Series/i.test(k));
    if (!seriesKey) return null;

    const series = json[seriesKey];
    const points = Object.entries(series)
      .map(([ts, ohlc]) => ({
        date: ts,
        price: Number(ohlc['4. close']),
      }))
      .filter(p => p.date && Number.isFinite(p.price))
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    return { data: points, meta: { seriesKey } };
  };

  const attempts = [
    { params: { function: 'TIME_SERIES_INTRADAY', symbol, interval: '5min', outputsize: 'compact', apikey: apiKey } },
    { params: { function: 'TIME_SERIES_DAILY', symbol, outputsize: 'compact', apikey: apiKey } },
    { params: { function: 'TIME_SERIES_DAILY_ADJUSTED', symbol, outputsize: 'compact', apikey: apiKey } },
    { params: { function: 'TIME_SERIES_WEEKLY', symbol, apikey: apiKey } },
    { params: { function: 'TIME_SERIES_MONTHLY', symbol, apikey: apiKey } },
  ];

  let lastErr;
  for (const a of attempts) {
    try {
      const r = await axios.get(base, { params: a.params });
      const parsed = parseSeries(r.data);
      if (parsed && parsed.data.length) {
        _cache = { ts: Date.now(), payload: parsed };
        return parsed;
      }
    } catch (e) {
      lastErr = e;
    }
  }
  throw new Error(lastErr?.message || 'No time series in response');
}

export function getStockData(points) {
  if (!Array.isArray(points) || points.length < 2) {
    return {
      currentPrice: '',
      priceChange: '',
      percentChange: '',
      lastUpdated: '',
    };
  }
  const last = points[points.length - 1];
  const prev = points[points.length - 2];
  const change = last.price - prev.price;

  return {
    currentPrice: last.price.toFixed(2),
    priceChange: change.toFixed(2),
    percentChange: ((change / prev.price) * 100).toFixed(2),
    lastUpdated: last.date,
  };
}